import { render, staticRenderFns } from "./stationsetting.vue?vue&type=template&id=97f1ec3e&scoped=true"
import script from "./stationsetting.vue?vue&type=script&lang=js"
export * from "./stationsetting.vue?vue&type=script&lang=js"
import style0 from "./stationsetting.vue?vue&type=style&index=0&id=97f1ec3e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "97f1ec3e",
  null
  
)

export default component.exports